module.exports = __webpack_public_path__ + "img/eva-bubianli.0b75e82a.jpg";